module.exports = __webpack_public_path__ + "img/Logo.4b42c0f4.svg";